<template>
  <div
    class="flex h-12 sm:h-16 rounded-full font-semibold text-center leading-none"
    :class="[
      active
        ? 'bg-gray-200 hover:bg-gray-300 text-gray-700'
        : 'bg-transparent mr-2 sm:mr-7 text-gray-100'
    ]"
    @click="active && $emit('update', !value)"
  >
    <button
      tabindex="-1"
      class="px-6 rounded-full"
      :class="[
        active ? (value == true ? 'bg-teal-500 text-white -mr-2' : '-mr-2') : ''
      ]"
      v-if="value == true || active"
      v-html="buttons[0] || ''"
    />

    <button
      tabindex="-1"
      class="px-6 rounded-full"
      :class="[
        active
          ? value == false
            ? 'bg-teal-500 text-white -ml-2'
            : '-ml-2'
          : 'mr-0 sm:mr-1'
      ]"
      v-if="value == false || active"
      v-html="buttons[1] || ''"
    />
  </div>
</template>

<script>
export default {
  name: 'InputBoolean',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    value: {
      type: Boolean,
      required: false,
      default: null
    },
    buttons: {
      type: Array,
      required: false,
      default() {
        return ['Yes', 'No']
      }
    }
  }
}
</script>
